function Badge({ text, className, textColor, backgroundColor }) {
  function getTextColor() {
    if (!textColor) return 'text-burnt-cognac-130';
    if (textColor.includes('#')) return `text-[${textColor}]`;
    return textColor;
  }

  function getBackgroundColor() {
    if (!backgroundColor) return 'bg-warm-pewter-80';
    if (backgroundColor.includes('#')) return `bg-[${backgroundColor}]`;
    return backgroundColor;
  }

  return (
    <span
      className={`inline-flex ${getTextColor()} ${getBackgroundColor()} w-fit rounded-[20px] px-[9px] py-[2px] ${className}`}
    >
      {text}
    </span>
  );
}

export default Badge;
